import React, { useState, useEffect } from "react";
import { Link, useLocation, Route } from "react-router-dom";
import Slider from "react-slick";
import NavArrow from "../components/NavArrow";
import PriceOffer from "../components/PriceOffer";
import ComplaintReport from "../components/ComplaintReport";
import CustomerService from "../components/CustomerService";
import DocumentNeeds from "../components/DocumentNeeds";
import GreenEnergyOffer from "../components/GreenEnergyOffer";
import Faq from "../components/Faq";
import SantralPage from "../components/SantralPage";
import Forms from "../components/Forms";
import bigicon from "./../img/expand-icon.png";
import zoom from "./../img/zoom.png";
import sepetpng from "./../img/sepetpng.png";
import leftmenuicon from "./../img/left-menu-icon-mobile.png";
import Lightbox from "react-image-lightbox";
import "./../styles/Activities.scss";
import Api from "../common/api";

const Activities = () => {
  const lang = localStorage.getItem("lang");
  const [tabs, setTabs] = useState();
  const [subTabs, setSubTabs] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState([]);
  const [currentSubTab, setCurrentSubTab] = useState([]);
  const [currentTabId, setCurrentTabId] = useState([]);
  const [currentSubTabId, setCurrentSubTabId] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isMobileActive, setIsMobileActive] = useState(false);
  const [Paths, setPaths] = useState(useLocation().pathname.split("/"));
  const location = useLocation();

  let tabParam = new URLSearchParams(location.search).get('q');
  let size = 2;
  if(lang == "en"){
    size = 3;
  }
  const [activePath, setActivePath] = useState(
    useLocation().pathname.split("/")[size]
  );
  const [banner, setBanner] = useState([]);
  
  React.useEffect(() => {
    Api.get("/home/getmenu?slug=" + Paths[size-1]).then((res) => {
      if (res.data.items) {
        setTabs(res.data.items);
        setBanner(res.data.banner);
        
        if(lang == "en"){
          setCurrentTab(
            res.data.items[res.data.items.findIndex((x) => x.Link_EN == activePath)]
          );
        }else{
          setCurrentTab(
            res.data.items[res.data.items.findIndex((x) => x.Link == activePath)]
          );
        }
      }
    });

    Api.get("/home/getleftmenu?slug=" + activePath).then((res) => {
      if (res.data.items.length > 0) {
        setSubTabs(res.data.items);

        if (tabParam != null && res.data.items[res.data.items.findIndex((x) => x.id == tabParam)] != null) {
          setCurrentSubTab(
            res.data.items[res.data.items.findIndex((x) => x.id == tabParam)]
          );
          setCurrentSubTabId(
            res.data.items[res.data.items.findIndex((x) => x.id == tabParam)].id
          );
        }
        else {
          setCurrentSubTab(res.data.items[0]);
          setCurrentSubTabId(res.data.items[0].id);
        }        
      }
    });
  }, [activePath]);

  let settings = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 5,
    initialSlide: 0,
    arrows: true,
    nextArrow: <NavArrow direction="right" />,
    prevArrow: <NavArrow direction="left" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const adClickTwo = (id) => {
    setCurrentSubTabId(id);
    setCurrentSubTab(subTabs.find((subTab) => subTab.id === id));
    setIsMobileActive(false);
  };

  const adClick = (id) => {
    setCurrentTabId(id);
    const tab = tabs.find((tab) => tab.id === id);
    setCurrentTab(tab);
    Api.get("/home/getleftmenu?slug=" + tab.Link).then((res) => {
      if (res.data.items.length > 0) {
        setSubTabs(res.data.items);
        setCurrentSubTab(res.data.items[0]);
        setCurrentSubTabId(res.data.items[0].id);
      }
    });
  };

  function RenderData(tab) {
    if (tab.content.id) {
      if (tab.content.Name === "Elektrik Üretimi") {
        return (
          <>
            <div className="activities-container container-sm">
              <h3 className="header-three marginli-header">
                {lang =="en" ? currentTab.Name_EN :currentTab.Name}
              </h3>
              <SantralPage />
            </div>
          </>
        );
      }
      if (tab.content.Name === "Elektrik Ticareti") {
        return (
          <>
            <div className="corporate-content-container full-width container-sm">
              <div className="tab-container">
                <ul>
                  {subTabs
                    ? subTabs.map((subTab) => {
                      return (
                        lang == "en" ? (
                          subTab.Name_EN  ? (
                        <li
                          className={
                            currentSubTabId === subTab.id ? "active" : null
                          }
                          onClick={() => adClickTwo(subTab.id)}
                          key={subTab.id}
                        >
                          <span>{subTab.Name_EN ? subTab.Name_EN : "null"}</span>
                        </li>
                        ):""
                        ):(
                          subTab.Name ? (
                          <li
                          className={
                            currentSubTabId === subTab.id ? "active" : null
                          }
                          onClick={() => adClickTwo(subTab.id)}
                          key={subTab.id}
                        >
                          <span>{subTab.Name ? subTab.Name : "null"}</span>
                        </li>
                          ):""
                        )
                      );
                    })
                    : null}
                </ul>
              </div>
              <button
                onClick={() => setIsMobileActive(!isMobileActive)}
                className={
                  !isMobileActive ? "mobile-toggle" : "mobile-toggle deactive"
                }
              >
                <img src={leftmenuicon} alt="sada" />
              </button>
              <div
                className={
                  isMobileActive
                    ? "mobile-tabs-corporate active"
                    : "mobile-tabs-corporate"
                }
              >
                <ul>
                  {subTabs
                    ? subTabs.map((subTab) => {
                      return (
                       lang == "en" ? (
                        subTab.Name_EN  ? (
                        <li
                        className={
                          currentSubTabId === subTab.id ? "active" : null
                        }
                        onClick={() => adClickTwo(subTab.id)}
                        key={subTab.id}
                      >
                        <span>{subTab.Name_EN ? subTab.Name_EN : "null"}</span>
                      </li>
                        ):""
                       ):(
                        subTab.Name ? (
                        <li
                          className={
                            currentSubTabId === subTab.id ? "active" : null
                          }
                          onClick={() => adClickTwo(subTab.id)}
                          key={subTab.id}
                        >
                          <span>{subTab.Name ? subTab.Name : "null"}</span>
                        </li>
                        ):""
                       )
                      );
                    })
                    : null}
                </ul>
              </div>
              <div className="corporate-container with-padding">
                {currentSubTab.content ? (
                  lang =="en" ? (
                    
                  <>
                    <h3 style={{ marginBottom: "20px", marginLeft: "0" }}>
                      {currentSubTab.content.Title_EN}
                    </h3>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: currentSubTab.content.Content_EN,
                      }}
                    ></div>
                  </>
                  ):(
                    <>
                    <h3 style={{ marginBottom: "20px", marginLeft: "0" }}>
                      {currentSubTab.content.Title}
                    </h3>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: currentSubTab.content.Content_TR,
                      }}
                    ></div>
                  </>
                  )
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        );
      }
      if (tab.content.Name === "Elektrik Satışı") {
        return (
          <>
            <div className="corporate-content-container container-sm">
              <div className="tab-container">
                <ul>
                  {subTabs
                    ? subTabs.map((subTab) =>
                      subTab.id == "1029" ? (
                        

                        lang == "en" ?(
                          subTab.Name_EN ? (
                        <li
                          className={
                            currentSubTabId === subTab.id ? "active" : null
                          }
                          key={subTab.id}
                        >
                          <a href={subTab.Link} target="_blank">
                            <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN : subTab.Name) : "null"}</span>
                          </a>
                        </li>
                          ):""
                         ):(
                            <li
                            className={
                              currentSubTabId === subTab.id ? "active" : null
                            }
                            key={subTab.id}
                          >
                            <a href={subTab.Link} target="_blank">
                              <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN : subTab.Name) : "null"}</span>
                            </a>
                          </li>
                          )
                      ) : (

                        lang == "en" ?(
                          subTab.Name_EN ? (
                          <li
                          className={
                            currentSubTabId === subTab.id ? "active" : null
                          }
                          onClick={() => adClickTwo(subTab.id)}
                          key={subTab.id}
                        >
                          <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN : subTab.Name) : "null"}</span>
                        </li>
                          ):""
                        ):(
                          subTab.Name ? (
                          <li
                          className={
                            currentSubTabId === subTab.id ? "active" : null
                          }
                          onClick={() => adClickTwo(subTab.id)}
                          key={subTab.id}
                        >
                          <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN : subTab.Name)  : "null"}</span>
                        </li>
                        ):""
                        )
                  
                      )
                    )
                    : null}
                </ul>
              </div>
              <button
                onClick={() => setIsMobileActive(!isMobileActive)}
                className={
                  !isMobileActive ? "mobile-toggle" : "mobile-toggle deactive"
                }
              >
                <img src={leftmenuicon} alt="sada" />
              </button>
              <div
                className={
                  isMobileActive
                    ? "mobile-tabs-corporate active"
                    : "mobile-tabs-corporate"
                }
              >
                <ul>
                  <li>
                    <span
                      onClick={() => adClickTwo(1026)}
                      className="elektrik-almak-istiyorum mobile"
                    >
                      <img src={sepetpng} alt="asdasd" />
                      {lang == "en" ? "I want to receive price quote" : "Elektrik Almak İstiyorum"}
                    </span>
                  </li>
                  {subTabs
                    ? subTabs.map((subTab) => {
                      return (
                        
                        lang == "en" ? (
                          subTab.Name_EN ? (
                        <li
                          className={
                            currentSubTabId === subTab.id ? "active" : null
                          }
                          onClick={() => adClickTwo(subTab.id)}
                          key={subTab.id}
                        >
                          <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN : subTab.Name)  : "null"}</span>
                        </li>
                        ):""
                        ):(

                          subTab.Name ? (
                            
                          <li
                          className={
                            currentSubTabId === subTab.id ? "active" : null
                          }
                          onClick={() => adClickTwo(subTab.id)}
                          key={subTab.id}
                        >
                          <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN : subTab.Name)  : "null"}</span>
                        </li>
                          ):""
                        )
                      );
                    })
                    : null}
                </ul>
              </div>
              <div className="corporate-container with-padding">
                <div className="electric-buy-btn">
                  <span
                    onClick={() => adClickTwo(1026)}
                    className="elektrik-almak-istiyorum"
                  >
                    <img src={sepetpng} alt="asdasd" />
                    {lang == "en" ? "I want to receive price quote" : "Elektrik Almak İstiyorum"}
                  </span>
                </div>
                {currentSubTab.content ? (
                  lang == "en" ? (
                  <>
                    <h3 style={{ marginBottom: "20px", marginLeft: "0" }}>
                      {currentSubTab.content.Title_EN}
                    </h3>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: currentSubTab.content.Content_EN,
                      }}
                    ></div>
                  </>
                  ):(
                    <>
                    <h3 style={{ marginBottom: "20px", marginLeft: "0" }}>
                      {currentSubTab.content.Title}
                    </h3>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: currentSubTab.content.Content_TR,
                      }}
                    ></div>
                  </>
                  )
                ) : null}
                {currentSubTab.Name === "Şikayet Özet Raporu" ? (
                  <ComplaintReport />
                ) : null}
                {currentSubTab.Name === "Müşteri Hizmetleri" ? (
                  <CustomerService />
                ) : null}
                {currentSubTab.Name === "Sözleşmeler ve Formlar" ? (
                  <Forms />
                ) : null}
                {currentSubTab.Name === "Sıkça Sorulan Sorular" ? (
                  <>
                    <h3 style={{ marginBottom: "20px", marginLeft: "0" }}>
                      {lang == "en" ? currentSubTab.Name_EN : currentSubTab.Name}
                    </h3>
                    <Faq />
                  </>
                ) : null}
                {currentSubTab.Name === "Fiyat Teklifi Almak İstiyorum" ? (
                  <PriceOffer />
                ) : null}
              </div>
            </div>
          </>
        );
      }
      if (tab.content.Name === "Yeşil Enerji") {
        return (
          <div className="corporate-content-container full-width container-sm">
            <div className="tab-container">
              <ul>
                {subTabs
                  ? subTabs.map((subTab) => {
                    return (
                      lang == "en" ?(
                        subTab.Name_EN ? (
                      <li
                        className={
                          currentSubTabId === subTab.id ? "active" : null
                        }
                        onClick={() => adClickTwo(subTab.id)}
                        key={subTab.id}
                      >
                       <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN:subTab.Name) : "null"}</span>
                      </li>
                      ):""
                      ):(
                        subTab.Name ? (
                        <li
                        className={
                          currentSubTabId === subTab.id ? "active" : null
                        }
                        onClick={() => adClickTwo(subTab.id)}
                        key={subTab.id}
                      >
                       <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN:subTab.Name) : "null"}</span>
                      </li>
                      ):""

                      )
                    );
                  })
                  : null}
              </ul>
            </div>
            <button
              onClick={() => setIsMobileActive(!isMobileActive)}
              className={
                !isMobileActive ? "mobile-toggle" : "mobile-toggle deactive"
              }
            >
              <img src={leftmenuicon} alt="sada" />
            </button>
            <div
              className={
                isMobileActive
                  ? "mobile-tabs-corporate active"
                  : "mobile-tabs-corporate"
              }
            >
              
              <ul>
                {subTabs
                  ? subTabs.map((subTab) => {
                    return (
                      lang == "en" ? (
                        subTab.Name_EN ? (
                      <li
                        className={
                          currentSubTabId === subTab.id ? "active" : null
                        }
                        onClick={() => adClickTwo(subTab.id)}
                        key={subTab.id}
                      >
                        <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN:subTab.Name) : "null"}</span>
                      </li>
                      ):""
                      ):(
                        subTab.Name ? (
                        <li
                        className={
                          currentSubTabId === subTab.id ? "active" : null
                        }
                        onClick={() => adClickTwo(subTab.id)}
                        key={subTab.id}
                      >
                        <span>{subTab.Name ? (lang == "en" ? subTab.Name_EN:subTab.Name) : "null"}</span>
                      </li>
                      ):""
                      )
                    );
                  })
                  : null}
              </ul>
            </div>
            <div className="corporate-container">
              <div className="electric-buy-btn">
                <span
                  onClick={() => adClickTwo(1032)}
                  className="elektrik-almak-istiyorum"
                >
                  <img src={sepetpng} alt="asdasd" />
                  
                  {lang == "en" ? "I want to receive a Green Energy quote" : "Yeşil Enerji fiyat teklifi almak istiyorum"}
                </span>
              </div>

              {currentSubTab.content ? (
                <>
                  <h3 style={{ marginBottom: "20px", marginLeft: "0" }}>
                    {lang == "en" ? currentSubTab.content.Title_EN : currentSubTab.content.Title}
                  </h3>
                  {lang == "en" ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: currentSubTab.content.Content_EN,
                    }}
                  ></div>
                  ):(
                    <div
                    dangerouslySetInnerHTML={{
                      __html: currentSubTab.content.Content_TR,
                    }}
                  ></div>
                  )}
                  {currentSubTab.content.Pop_up ? (
                    <>
                      <div
                        className="popup-image"
                        onClick={() => setIsOpen(true)}
                      >
                        <img className="download-btn-absolute" src={lang == "en" ? zoom : bigicon} />
                        <img
                          className="general-image"
                          src={
                            "https://sankoenerji.com.tr" +
                            currentSubTab.content.Pop_up
                          }
                          width="100%"
                          alt={currentSubTab.content.Title}
                        />
                      </div>
                      {isOpen && (
                        <Lightbox
                          mainSrc={
                            "https://sankoenerji.com.tr" +
                            currentSubTab.content.Pop_up
                          }
                          onCloseRequest={() => setIsOpen(false)}
                          animationDuration="100"
                        />
                      )}
                    </>
                  ) : null}
                </>
              ) : null}

              {currentSubTab.Name ===
                "Yeşil Enerji Fiyat Teklifi Almak İstiyorum" ? (
                <GreenEnergyOffer />
              ) : null}
            </div>
          </div>
        );
      }
    } else {
      return "";
    }
  }

  const renderTitle = () => {
    if (currentTab) {
      if (lang == "en") {
      return <h3>{currentTab.Name_EN}</h3>;
      }else{
        return <h3>{currentTab.Name}</h3>;
      }
    }
  };

  return (
    <>
      <header
        className="corporate-header"
        style={{
          backgroundImage:
            `url("https://sankoenerji.com.tr` + banner + `")`,
        }}
      ></header>
      <div className="slider-deneme full-width-slick container-sm">
        <Slider className="slider-tab full-width-slider" {...settings}>
          {tabs
            ? tabs.map((tab) => {
              return (
                lang == "en" ? (

                  tab.Name_EN? (
                  <Link
                    className={currentTab.id === tab.id ? "tab active" : "tab"}
                    key={tab.id}
                    to={"/en/" + Paths[size-1] + "/" + tab.Link_EN}
                    onClick={() => adClick(tab.id)}
                  >
                    {tab.Name_EN}
                  </Link>
                ):""
                ) :(<Link
                  className={currentTab.id === tab.id ? "tab active" : "tab"}
                  key={tab.id}
                  to={"/" + Paths[1] + "/" + tab.Link}
                  onClick={() => adClick(tab.id)}
                >
                  {tab.Name}
                </Link>)
              );
            })
            : null}
        </Slider>
      </div>
      <div className="breadcrumbz container-sm">
        {lang ==  "en" ? (
        <ol>
          <li>
            <Link to="/">
              Homepage <span>&gt;</span>
            </Link>
          </li>
          <li>
            <a href="/faaliyet-alanlari/elektrik-uretimi">
              Activities <span>&gt;</span>
            </a>
          </li>
          <li>
            {tabs || currentTab.id ? (
              <Link to="/corporate">{renderTitle()}</Link>
            ) : null}
          </li>
        </ol>
        ) : (
          <ol>
          <li>
            <Link to="/">
              Anasayfa <span>&gt;</span>
            </Link>
          </li>
          <li>
            <a href="/faaliyet-alanlari/elektrik-uretimi">
              Faaliyetlerimiz <span>&gt;</span>
            </a>
          </li>
          <li>
            {tabs || currentTab.id ? (
              <Link to="/corporate">{renderTitle()}</Link>
            ) : null}
          </li>
        </ol>
        )}
      </div>
      <div className={"mobile-tabs-corporate active"}>
        <ul>
          {tabs
            ? tabs.map((tab) => {
              return (
                lang ==  "en" ? (
                <li
                  className={currentTabId === tab.id ? "active" : null}
                  onClick={() => adClick(tab.id)}
                  key={tab.id}
                >
                  <span>{tab.Name_EN}</span>
                </li>
                ) : (
                  <li
                    className={currentTabId === tab.id ? "active" : null}
                    onClick={() => adClick(tab.id)}
                    key={tab.id}
                  >
                    <span>{tab.Name}</span>
                  </li>)
              );
            })
            : null}
        </ul>
      </div>

      <Route>
        <RenderData content={currentTab} />
      </Route>
    </>
  );
};

export default Activities;
